export default __webpack_public_path__ + "static/media/bg-1.6416b1cc.png";